import React from "react";
import TextInput from "../Common/FormElements/TextInput/TextInput";
import { useTranslation } from "react-i18next";
import { IMAGE_END_POINT } from "../../Api/EndPoints";
import { formatCurrency, getProductType } from "../../Utils";

const AvoirCard = ({
  isDelivery = false,
  data,
  totalHT,
  isParticulier,
  handleChange,
  handleDelete,
}) => {
  const { t, i18n } = useTranslation("common");

  if (isDelivery) {
    return (
      <div className="f14 bold text-dark">
        <div className="br10 p-2 alignH justify-content-between w100">
          <div className="d-flex flex-grow-1 justify-content-between align-items-center">
            <span className="f12 bold">{t("Delivery charges excl. tax")}</span>
            <TextInput
              name="delivery"
              className="f12 bold"
              value={data?.delivery}
              euro
              callback={handleChange}
            />
          </div>
          <button
            className="bold alignC qteButton f16 br6 ms-3"
            onClick={handleDelete}
          >
            -
          </button>
        </div>
      </div>
    );
  }

  const packing = data[0];
  const image =
    packing?.attributes?.model?.data?.attributes?.attachments?.data[0]
      ?.attributes?.file?.data;
  const quantity = data.length;

  const total = data?.reduce((acc, packing) => {
    return (
      (acc ?? 0) +
      (packing?.attributes.soldPrice -
        (packing?.attributes?.discount ?? 0) -
        (packing?.attributes?.globalDiscount ?? 0) ?? 0)
    );
  }, 0);

  return (
    <div className="f14 bold text-dark">
      <div className="d-flex flex-column mb-3">
        {image?.attributes?.url && (
          <img
            src={`${IMAGE_END_POINT}${image?.attributes?.url}`}
            alt=""
            width={50}
            height={50}
            className="objec-cover mb-3"
          />
        )}
        <div className="d-flex">
          <span className="">
            {i18n?.language?.includes("en")
              ? packing?.attributes?.model?.data?.attributes?.name_en ||
                packing?.attributes?.name ||
                packing?.attributes?.reference
              : packing?.attributes?.model?.data?.attributes?.name ||
                packing?.attributes?.name ||
                packing?.attributes?.reference}
          </span>
          {(packing?.attributes?.cuve || packing?.attributes?.panel) && (
            <span className="mt-1">
              - {packing?.attributes?.cuve}/{packing?.attributes?.panel}
            </span>
          )}
          {packing?.attributes?.serialNumber && (
            <span className="mt-1">- {packing?.attributes?.serialNumber}</span>
          )}
        </div>
        <span className="text-softBlue f12">
          {getProductType(
            packing?.attributes?.model?.data?.attributes?.productType,
            t,
          )}
        </span>
      </div>
      <div className="border br10 p-2 alignH justify-content-between w100">
        <div className="d-flex flex-column">
          <span className="f14 bold">
            {t("Quantity")} : {quantity}
          </span>
          <span className="f12 bold">
            {isParticulier
              ? t("Unit Price incl. tax")
              : t("Unit Price excl. tax")}{" "}
            : {formatCurrency(total / quantity)}
          </span>
          <span className="f12 bold">
            {isParticulier
              ? t("Total Price incl. tax")
              : t("Total Price excl. tax")}{" "}
            : {formatCurrency(total)}
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <TextInput
            name="packings"
            className="f12 bold"
            value={totalHT}
            callback={handleChange}
            euro
          />
          <button
            className="bold alignC qteButton f16 br6"
            onClick={handleDelete}
          >
            -
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvoirCard;
